import React from 'react';
import { useNavigate, useParams, useSearchParams, Link } from 'react-router-dom';

export default function PaymentSuccessPage() {
  const { businessId } = useParams();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const cartId = sp.get('cart_id');

  return (
    <div className="max-w-xl mx-auto p-6 text-center">
      <h1 className="text-2xl font-semibold mb-2">Thanks! Payment completed</h1>
      <p className="text-gray-600 mb-6">
        We’re finalizing your reservation. You can view it in “My Reservations”.
      </p>
      <div className="flex gap-3 justify-center">
        <Link className="px-4 py-2 rounded bg-black text-white" to="/my-reservations">Go to My Reservations</Link>
        <button className="px-4 py-2 rounded border" onClick={() => navigate(`/reserve/${businessId}`)}>Back to booking</button>
      </div>
      {cartId && (
        <div className="text-xs text-gray-400 mt-4">Cart: {cartId}</div>
      )}
    </div>
  );
}
